"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a SESSION_PROPERTIES_EVENT request.
 */
var SessionPropertiesEvent = /** @class */ (function () {
    /**
     * Create a new SessionPropertiesEvent instance
     *
     * @param sessionId      the target session ID
     * @param type           the type of the event
     * @param updateType     in case of an UPDATE event, the type of the update
     * @param oldProperties  the old session properties
     * @param newProperties  the new session properties
     * @param closeReason    the reason for closing the session
     */
    function SessionPropertiesEvent(sessionId, type, updateType, oldProperties, newProperties, closeReason) {
        this.sessionId = sessionId;
        this.type = type;
        this.updateType = updateType;
        this.oldProperties = oldProperties;
        this.newProperties = newProperties;
        this.closeReason = closeReason;
    }
    return SessionPropertiesEvent;
}());
exports.SessionPropertiesEvent = SessionPropertiesEvent;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/session-properties-event.js
// module id = 1296
// module chunks = 1